import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Header from "@/components/header";
import { useTranslation } from "@/i18n/LanguageContext";
import { useTitle } from "@/hooks/use-title";

export default function CacatalPage() {
  const { t } = useTranslation();
  useTitle(t("cacatal.title"));

  return (
    <>
      <Header />
      <div className="container mx-auto px-4 py-8 space-y-8 mt-20">
        {/* Hero Section */}
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold">{t("cacatal.title")}</h1>
          <p className="text-xl text-zinc-400 max-w-2xl mx-auto">
            {t("cacatal.subtitle")}
          </p>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Objective */}
          <Card className="bg-zinc-900 border-zinc-800">
            <CardHeader>
              <CardTitle>{t("cacatal.objective.title")}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-zinc-400">
                {t("cacatal.objective.description")}
              </p>
            </CardContent>
          </Card>

          {/* Game Mechanics */}
          <Card className="bg-zinc-900 border-zinc-800">
            <CardHeader>
              <CardTitle>{t("cacatal.gameMechanics.title")}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <h3 className="font-semibold mb-2">{t("cacatal.gameMechanics.searchPool.title")}</h3>
                <p className="text-zinc-400">{t("cacatal.gameMechanics.searchPool.description")}</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">{t("cacatal.gameMechanics.rewards.title")}</h3>
                <p className="text-zinc-400">{t("cacatal.gameMechanics.rewards.description")}</p>
                <ul className="list-disc list-inside mt-2 text-zinc-400">
                  <li>{t("cacatal.gameMechanics.rewards.regularBlock")}</li>
                  <li>{t("cacatal.gameMechanics.rewards.bigBlock")}</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-2">{t("cacatal.gameMechanics.tokenUsage.title")}</h3>
                <p className="text-zinc-400">{t("cacatal.gameMechanics.tokenUsage.description")}</p>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Technology & Tokenomics */}
        <div className="space-y-6">
          <Card className="bg-zinc-900 border-zinc-800">
            <CardHeader>
              <CardTitle>{t("cacatal.technology.title")}</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2 text-zinc-400">
                <li>{t("cacatal.technology.blockchain")}</li>
                <li>{t("cacatal.technology.smartContracts")}</li>
                <li>{t("cacatal.technology.webPlatform")}</li>
              </ul>
            </CardContent>
          </Card>

          <Card className="bg-zinc-900 border-zinc-800">
            <CardHeader>
              <CardTitle>{t("cacatal.tokenomics.title")}</CardTitle>
              <CardDescription>{t("cacatal.tokenomics.totalSupply")}</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span>{t("cacatal.tokenomics.poolRewards")}</span>
                  <span className="text-green-500">50%</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>{t("cacatal.tokenomics.marketing")}</span>
                  <span className="text-blue-500">30%</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>{t("cacatal.tokenomics.development")}</span>
                  <span className="text-purple-500">10%</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>{t("cacatal.tokenomics.futureReserves")}</span>
                  <span className="text-yellow-500">10%</span>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Roadmap */}
          <Card className="bg-zinc-900 border-zinc-800">
            <CardHeader>
              <CardTitle>{t("cacatal.roadmap.title")}</CardTitle>
            </CardHeader>
            <CardContent>
              <Accordion type="single" collapsible className="w-full">
                <AccordionItem value="phase1">
                  <AccordionTrigger>{t("cacatal.roadmap.phase1.title")}</AccordionTrigger>
                  <AccordionContent>
                    {t("cacatal.roadmap.phase1.description")}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="phase2">
                  <AccordionTrigger>{t("cacatal.roadmap.phase2.title")}</AccordionTrigger>
                  <AccordionContent>
                    {t("cacatal.roadmap.phase2.description")}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="phase3">
                  <AccordionTrigger>{t("cacatal.roadmap.phase3.title")}</AccordionTrigger>
                  <AccordionContent>
                    {t("cacatal.roadmap.phase3.description")}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="phase4">
                  <AccordionTrigger>{t("cacatal.roadmap.phase4.title")}</AccordionTrigger>
                  <AccordionContent>
                    {t("cacatal.roadmap.phase4.description")}
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
}